import { render, staticRenderFns } from "./RefereeMatchCard.vue?vue&type=template&id=f3228fd8&scoped=true"
import script from "./RefereeMatchCard.vue?vue&type=script&lang=js"
export * from "./RefereeMatchCard.vue?vue&type=script&lang=js"
import style0 from "./RefereeMatchCard.vue?vue&type=style&index=0&id=f3228fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3228fd8",
  null
  
)

export default component.exports